import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const VkScaleMediumAppearanceDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.0646 19C5.39898 19 1.02668 13.7447 0.844498 5H4.68434C4.81046 11.4184 7.64122 14.1371 9.88347 14.6977V5H13.4992V10.5355C15.7134 10.2973 18.0395 7.77477 18.8243 5H22.44C21.8373 8.41942 19.3148 10.9419 17.521 11.979C19.3148 12.8198 22.1878 15.02 23.2809 19H19.3008C18.446 16.3373 16.316 14.2773 13.4992 13.997V19H13.0646Z"
                fill="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            />
        </svg>
    ),
    'Vk'
);
export default VkScaleMediumAppearanceDefault;
